import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { logOperatorUiBuildInfo } from "./lib/logBuildInfo";
import { restoreViewerTheme } from "./lib/theme";
import "./styles/index.scss";

logOperatorUiBuildInfo();
restoreViewerTheme();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
